import { useMemo } from 'react';
import { useUseCases } from "@/context/UseCasesProvider";

export interface ExtractionField {
  title: string;
  text: string;
  key: string;
  type: "string" | "address" | "date" | "price" | "select";
  choice?: string[];
  isErasable: boolean;
  isMandatory: boolean;
  isVisible: boolean;
  isExportable: boolean;
}

export interface AddressMatchingConfig {
  value: boolean;
  onlyInDeliveryPerCustomer?: boolean;
  proposeDefaultIfNoMatch?: boolean;
  confidence_proposeDefaultIfNoMatch?: number;
  [key: string]: any;
}

export interface ChecksOrderMetadata {
  sender_address_matching?: AddressMatchingConfig;
  billing_address_matching?: AddressMatchingConfig;
  delivery_address_matching?: AddressMatchingConfig;
  [key: string]: any;
}

interface ConfigFieldsResult {
  extractionFields: ExtractionField[];
  quantityMoqVerification: boolean | null;
  checksOrderMetadata: ChecksOrderMetadata;
  loading: boolean;
  error: Error | null;
}

const useConfigFieldsValues = (): ConfigFieldsResult => {
  const data = useUseCases();

  return useMemo(() => {
    if (!data) {
      return {
        extractionFields: [],
        quantityMoqVerification: null,
        checksOrderMetadata: {},
        loading: false,
        error: null,
      };
    }

    const extractionFields = data.settings?.processing?.metadata?.extractionFields ?? [];
    const quantityMoqVerification =
      data.settings?.checks_order_products?.quantity_moq_verification?.value ??
      data.settings?.checks?.order?.products?.quantity_moq_verification?.value ??
      null;
    const checksOrderMetadata = data.settings?.checks_order_metadata ?? {};

    return {
      extractionFields,
      quantityMoqVerification,
      checksOrderMetadata,
      loading: false,
      error: null,
    };
  }, [data]);
};

export default useConfigFieldsValues;